export default __webpack_public_path__ + "static/media/avatar8.bad6ce3a.svg";